// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0d337a3a","239":"04d0a6b0","453":"025066b1","455":"6156a9b2"}[chunkId] + ".chunk.js";
};